import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ALMACENES_LISTA, ALMACENES_NUEVO } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function AlmacenesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ALMACENES_LISTA}`} component={ListaPage} />
        <Route path={`/${ALMACENES_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${ALMACENES_NUEVO}`} component={NuevoPage} />
      </Switch>
    </Suspense>
  )
}
